import { DataWrapped, Influencer, Location } from '@cardo/types';
import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export * from './brandedPage';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function getInfluencerName(
  influencer: Influencer | DataWrapped<Influencer> | DataWrapped<null>,
) {
  if ('data' in influencer && influencer.data === null) {
    return '';
  }

  const attributes =
    'data' in influencer ? influencer.data.attributes : influencer.attributes;
  return attributes.displayName || attributes.username;
}

export const formatLocationString = (
  location?: Location | null,
  options: { withPlaceName: boolean } = { withPlaceName: false },
) => {
  if (!location) return '';

  const { withPlaceName } = options;

  if (
    location.attributes.placeType === 'address' &&
    location.attributes.mapbox?.place_name
  ) {
    return location.attributes.mapbox?.place_name;
  }

  const place = withPlaceName
    ? location.attributes.placeName
    : location.attributes.place;

  const parts = [];

  if (place) parts.push(place);
  if (location.attributes.region) parts.push(location.attributes.region);
  if (location.attributes.country) parts.push(location.attributes.country);

  return parts.join(', ');
};

export const getHotelGroupColor = (hotelGroupName: string) => {
  switch (hotelGroupName) {
    case 'Accor':
      return '#7C3AED'; // Purple
    case 'Choice Hotels':
      return '#F59E0B'; // Amber
    case 'Hilton':
      return '#003A70'; // Dark Blue
    case 'Hyatt':
      return '#007FA3'; // Teal
    case 'IHG':
      return '#EA580C'; // Orange
    case 'Marriott':
      return '#B91C1C'; // Red
    case 'Wyndham':
      return '#005B9F'; // Blue
    default:
      return '#5B7083'; // Default gray
  }
};
